import PropTypes from 'prop-types';
import React from 'react';
import InstructionsCard from './InstructionsCard';
import {Button} from 'components/layout';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class InstructionsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let {formatMessage} = this.props.intl;
    let {title, submitLabel = formatMessage({id: 'general.start'}), onSubmit, cancelHref = '#tools/accounts', remember, instructions, children} = this.props;

    return <div className='instructions-view'>
      <h2 className='instructions-view__header'><FormattedMessage id={title} /></h2>

      <p className='instructions-view__remember'><FormattedMessage id="general.remember" />:</p>
      <ol className='instructions-view__remember-list'>{remember.map((x, i) => <li key={i}><FormattedMessage id={x} /></li>)}</ol>

      <p className='instructions-view__warning'>
        <i className='bl bl-help-circle blue fa-lg' />
        <span className='error'><FormattedMessage id="instructions.view.cannot.undone" /></span>
      </p>

      {instructions && instructions.length > 0 ? <div>
        <h3 className='instructions-view__how-works-header'><FormattedMessage id="instructions.view.how.works" /></h3>
        <div className='row instructions-view__cards'>
          {instructions.map((x, i) => <InstructionsCard key={i} title={formatMessage({id: x.title})}>{ typeof x.body === 'string' ? <p>{formatMessage({id: x.body})}</p> : formatMessage({id: x.body}) }</InstructionsCard>)}
        </div>
      </div> : null}

      {children}

      <div className='row'>
        <div className='col-md-12'>
          <div className='pull-right'>
            <Button href={cancelHref} default className='instructions-view__cancel'><FormattedMessage id="general.cancel" /></Button>
            <Button primary onClick={onSubmit}>{submitLabel}</Button>
          </div>
        </div>
      </div>
    </div>;
  }
}
InstructionsView.propTypes = {
  cancelHref: PropTypes.string,
  children: PropTypes.node,
  instructions: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  remember: PropTypes.array.isRequired,
  submitLabel: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default injectIntl(InstructionsView);
